import { render, staticRenderFns } from "./ProcessHeader.vue?vue&type=template&id=4993b848&scoped=true&"
import script from "./ProcessHeader.vue?vue&type=script&lang=ts&"
export * from "./ProcessHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ProcessHeader.vue?vue&type=style&index=0&id=4993b848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4993b848",
  null
  
)

export default component.exports